<template>
  <div id="app">
    <div v-if="setting.isMobile">
      <wapHead/>
      <router-view/>
      <ContentBottom v-if="this.$route.path!='/News'"/>
    </div>
    <div v-else>
      <Head/>
      <router-view/>
      <Bottom/>
    </div>
  </div>
</template>

<script>
  import Head from './components/Head.vue'
  import Bottom from './components/Bottom.vue'
  import 'vue-ydui/dist/ydui.base.css'
  import wapHead from './components/wapHead.vue'
  import ContentBottom from './components/contentBottom.vue'

  import './assets/css/common.css'
  export default {
    data() {
      return {
        setting :{
          isMobile: /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)
        }
      }
    },
    components:{
      Head,
      Bottom,
      wapHead,
      ContentBottom
    },
    computed: {
      routepath (){
        return this.$route.path
      }
    },
    watch: {
      routepath: {
        handler (value) {
          this.$WxShare()
        },
        deep: true,
        immediate: true
      }
    },
  }
</script>

<style  scoped lang="less">
  #app {
    height: auto;
    width: 100%;
    background-color: #1D3662;
    /*border: 1px solid #1D3662;*/
    position: relative;
  }
</style>
